//import axios from 'axios';




const state={
    classes:[
      {
        id: "1", 
        Classe: "Première année",
        Nombreeleves: "30",
      },
      {
        id: "2", 
        Classe: "Première année",
        Nombreeleves: "30",
      },
      {
        id: "3", 
        Classe: "Première année",
        Nombreeleves: "30",
      },
      {
        id: "4", 
        Classe: "Première année",
        Nombreeleves: "30",
      },
      {
        id: "5", 
        Classe: "Première année",
        Nombreeleves: "30",
      },
      {
        id: "6", 
        Classe: "Première année",
        Nombreeleves: "30",
      },
    
    ]
};

const getters={
    ClassesPagination:(state)=>(from,to)=>state.classes.slice(from,to),
    allClasses:(state)=>state.classes
};

const actions={};

const mutations={};


export default{
    state,
    getters,
    actions,
    mutations
}



